import { render } from "./CommonFunction.vue?vue&type=template&id=60c0bd7f"
import script from "./CommonFunction.vue?vue&type=script&lang=js"
export * from "./CommonFunction.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__